import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [ChargeProductTypes, ChargeProductTypeSchema] = EnumBuilder(
  'package',
  'add-on',
  'misc'
)

export type ChargeProductType = ZodInfer<typeof ChargeProductTypeSchema>
